module.exports = __webpack_public_path__ + "static/media/farbeIcon.56334bc1.svg";